import styled from "styled-components";

export const LogoStyled404 = styled.img`
  width: 150px;  
  border-radius: 50%;
`;